import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { THEME_MESSAGES } from 'utils/constants';
import {
  getLaundroworksSettings,
  LaundroworksSettingsResponse,
} from 'api/admin/businesses/getLaundroworksSettings';
import { ApiError } from 'types/api';

export const useLaundroworksSettings = (businessId: number | string | null) => {
  return useQuery<LaundroworksSettingsResponse, ApiError>({
    queryKey: ['laundroworksSettings', businessId],
    queryFn: async () => {
      if (!businessId) {
        throw new Error('Business ID is required');
      }

      const { data } = await getLaundroworksSettings(businessId);

      return data;
    },
    enabled: !!businessId,
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(error?.response?.data?.error ?? THEME_MESSAGES.somethingWrong, {
        duration: 4000,
      });
    },
  });
};
